// import React from 'react';
import { useSelector } from 'react-redux';
import Nav from '../components/Nav/Nav';
import Movie from '../components/Movie/Movie';
import MovieMain from '../components/Main/MovieMain';

const Movies = () => {
  const action = useSelector((state) => state.action);
  const comedy = useSelector((state) => state.comedy);
  const documentary = useSelector((state) => state.documentary);
  const horror = useSelector((state) => state.horror);
  const romance = useSelector((state) => state.romance);
  const topRated = useSelector((state) => state.topRated);
  const trending = useSelector((state) => state.trending);
  const kidsAndFamily = useSelector((state) => state.kidsAndFamily);
  const animation = useSelector((state) => state.animation);
  const adventure = useSelector((state) => state.adventure);
  const crime = useSelector((state) => state.crime);
  const drama = useSelector((state) => state.drama);
  const fantasy = useSelector((state) => state.fantasy);
  const history = useSelector((state) => state.history);
  const music = useSelector((state) => state.music);
  const mystery = useSelector((state) => state.mystery);
  const scienceFiction = useSelector((state) => state.scienceFiction);
  const thriller = useSelector((state) => state.thriller);
  const tvMovie = useSelector((state) => state.tvMovie);
  return (
    <>
      <Nav />
      <MovieMain />
      <div className="all-movies">
        <div className="main-movie-section flixfrenzy-originals">
          <Movie fetchUrl={trending} title="Trending Now" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={topRated} title="Top Rated" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={action} title="Action Movies" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={comedy} title="Comedy Movies" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={drama} title="Drama" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={horror} title="Horror Movies" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={romance} title="Romance Movies" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={fantasy} title="Fantasy" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={kidsAndFamily} title="Kids & Family" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={adventure} title="Adventure" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={mystery} title="Mystery" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={animation} title="Animation" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={history} title="History" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={thriller} title="Thriller" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={tvMovie} title="TV Movie" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={crime} title="Crime" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={music} title="Music" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={scienceFiction} title="Science Fiction" />
        </div>

        <div className="main-movie-section">
          <Movie fetchUrl={documentary} title="Documentaries" />
        </div>
      </div>
    </>
  );
};

export default Movies;
